module.exports = coreApis.shadowRoot;